import * as React from 'react';

interface LogoWordmarkProps {
    height?: number;
    /** Theme-aware color (e.g. sidebar text color). Defaults to currentColor. */
    color?: string;
    /** Opacity of the fill (0–1). Default 0.25 for subtle, 1 for full. */
    opacity?: number;
}

const LogoWordmark: React.FC<LogoWordmarkProps> = ({ height = 16, color = 'currentColor', opacity = 0.25 }) => {
    const width = (99 / 16) * height;
    const fill = color;
    const fillOpacity = opacity;

    return (
        <svg
            width={width}
            height={height}
            viewBox="0 0 99 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            style={{ display: 'block' }}
            aria-hidden
        >
            <path
                d="M2.30694 2.71899H6.10978C6.85472 2.85661 7.40743 3.20637 7.76789 3.76829C8.15238 4.46781 8.08028 5.21321 7.55161 6.00448C7.20317 6.40585 6.69252 6.65814 6.01966 6.76135H2.30694V2.71899ZM0 0.5L0 15.2933H2.37903V9.04914H6.1278L8.7231 15.3105H11.3004L8.39869 8.30948C8.67504 8.126 8.88531 7.97692 9.02949 7.86224C9.18569 7.74757 9.3539 7.57555 9.53413 7.3462C9.72638 7.11684 9.87056 6.87029 9.96669 6.60653C10.4713 5.64325 10.5614 4.60542 10.237 3.49306C9.96068 2.69032 9.51611 2.03093 8.90333 1.51489C8.21846 0.930038 7.35937 0.591742 6.32605 0.5H0Z"
                fill={fill}
                fillOpacity={fillOpacity}
            />
            <path
                d="M17.0857 0.672016V11.7842C17.3501 12.7933 18.0229 13.705 19.1043 14.5192C20.2097 15.1843 21.3151 15.5112 22.4205 15.4997C23.8984 15.4309 25.0759 14.9894 25.953 14.1752C26.8422 13.4757 27.3708 12.6213 27.539 11.6122V0.654814H25.178V11.2853C24.9137 12.0193 24.355 12.5984 23.5019 13.0227C22.5167 13.3209 21.6095 13.2463 20.7804 12.7991C20.1557 12.5583 19.7351 12.025 19.5188 11.1993V0.672016H17.0857Z"
                fill={fill}
                fillOpacity={fillOpacity}
            />
            <path
                d="M34.3878 15.4825H36.7307V5.38523L42.2638 15.4825H44.7509V0.706419H42.426V10.8725L36.8929 0.706419H34.3697L34.3878 15.4825Z"
                fill={fill}
                fillOpacity={fillOpacity}
            />
            <path
                d="M51.6357 0.654814L53.8345 15.4653H56.2676L58.4484 5.98728L60.6472 15.4481H63.0983L65.225 0.672016H62.864L61.6384 8.99754L59.6559 0.689218H57.2408L55.3124 8.96314L54.0868 0.654814H51.6357Z"
                fill={fill}
                fillOpacity={fillOpacity}
            />
            <path
                d="M77.6969 8.79112H74.5248L76.1109 4.38754L77.6969 8.79112ZM82.6352 15.4825L77.4085 0.620412H74.9214L69.5866 15.4825H72.1819L73.7318 11.0789H78.4358L80.0399 15.4825H82.6352Z"
                fill={fill}
                fillOpacity={fillOpacity}
            />
            <path
                d="M91.3222 8.92873L91.2862 15.3793L93.6472 15.3621V8.85993L99 0.534404H96.1344L92.4577 6.29691L88.7089 0.534404H85.9334L91.3222 8.92873Z"
                fill={fill}
                fillOpacity={fillOpacity}
            />
        </svg>
    );
};

export default LogoWordmark;
